import React from 'react';
import {Link} from 'react-router-dom';

class MenuItem extends React.Component {

    constructor(props) {
        super(props);
    }

    itemClicked(event) {
        this.props.itemClicked(event.target.parentElement.getAttribute('id'));
    }

    render() {
        let {
            id,
            active,
            to,
            title,
        } = this.props;
        
        return (
            <li id={id}
                className={active ? 'active' : null}>
                <Link
                    onClick={this.itemClicked.bind(this)}
                    to={to}
                >
                    {title}
                </Link>
            </li>
        );
    };
}

export default MenuItem;




// WEBPACK FOOTER //
// ./web/src/components/navigation/MenuItem.jsx